import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-6" data-id="element-79" data-mp="1o46konudlsx5">
      <div className="mx-auto max-w-3xl rounded-2xl border border-brand-gold/45 bg-brand-cloud p-4 text-center shadow-sm sm:p-5" data-id="element-80" data-mp="1o33xor06cami">
        <p className="mb-1 text-xs font-extrabold uppercase tracking-widest text-brand-blue sm:text-sm" data-id="element-81" data-mp="1x4bsgz3hetbu">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="mx-auto mb-1.5 flex h-12 w-12 items-center justify-center rounded-full bg-brand-sage" data-id="element-82" data-mp="19fae6v7ywnyn">
          <ShieldCheckIcon className="h-6 w-6 text-brand-blue" data-id="element-83" data-mp="14hh8e3aktvyw" />
        </div>
        <h2 className="mb-2 text-xl font-extrabold uppercase sm:text-2xl" data-id="element-84" data-mp="1j5c29n0bm6dk">
          🛡️ 7-Day Money-Back Guarantee
        </h2>
        <p className="mx-auto max-w-2xl text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-85" data-mp="1ebr3vtutfadu">
          Your purchase is completely risk-free. Take seven full days to explore the entire system, review every module, and start using the resources with your patients. If for any reason you're not completely satisfied, we'll refund 100% of your purchase. No questions asked.
        </p>
      </div>
    </section>;
}